export const isNotFoundRoute = (path: string[], options: { notFound?: boolean }) => {
  // Page not found
  if (options.notFound || path[0] === 'not-found') return true;
  return false;
};
